import { Link } from "react-router-dom";
import { useMe } from "@/context/Me";
import { Tape } from "@/components/bits";
import { DEFAULT_STORY } from "@/lib/api";

export default function Story() {
  const { meta } = useMe();
  const paras = (meta?.story || DEFAULT_STORY).split(/\n\s*\n/);
  return (
    <div className="mx-auto max-w-3xl px-4 py-14 sm:px-6">
      <div className="eyebrow mb-3">Nossa história</div>
      <h1 className="mb-8 text-5xl font-black uppercase leading-none sm:text-6xl">De uma infiltração<br /><span className="text-[#FFC700]">a um app.</span></h1>
      <Tape className="mb-10 rounded" />
      <article data-testid="story-text" className="space-y-6 text-lg leading-relaxed text-slate-300">
        {paras.map((p, i) => <p key={i} className={i === paras.length - 1 ? "font-display text-3xl font-black uppercase text-[#FFC700]" : ""}>{p}</p>)}
      </article>
      <Link to="/diagnostico" data-testid="story-cta" className="btn-hazard mt-12">Experimentar o orçamento por foto</Link>
    </div>
  );
}
